// @flow
import React, { useCallback, useState } from 'react';

import ReportSectionCSS from 'app/components/common/reports/ReportSectionCSS';
import Loader from 'app/common/components/Loader';
import EmptyReport from 'app/components/Reports/common/EmptyReport';
import HistoryLink, { reportTypes } from 'app/components/common/reports/history/HistoryLink';

import HeaderBar from './HeaderBar';
import Students from './Students';
import Classes from './Classes';
import Schools from './Schools';
import ClassesAndOrders from './ClassesAndOrders';
import Summary from './Summary';
import { NoGroup } from './NoGroup';
import { ByAllowances } from './ByAllowances';
import { ByAllowancesAndFoodModes } from './ByAllowancesAndFoodModes';
import enhanceReport from './enhanceReport';
import { ReportSection } from 'app/common/templates-next/report-template';


type Props = {
  loading: boolean,
  reportId: number,
}

const Report = ({ loading, reportId }: Props) => {
  const [fs, changeFullScreen] = useState(false);
  const toggleFS = useCallback(() => {
    changeFullScreen(fullscreen => !fullscreen);
  }, []);

  if (!reportId) {
    return (
      <EmptyReport
        headerBar={
          <HistoryLink reportType={reportTypes.REPORT_SUBSIDIES_DETAILED} />
        }
      />
    );
  }

  return (
    <ReportSection
      header="Отчет «Дотации»"
      headerBar={<HeaderBar />}
      fullscreenEnabled
      skipPadding
    >
      {loading
        ? <Loader />
        : <React.Fragment>
          {/* Общая иформация */}
          <Summary />
          {/* Далее таблицы с отчетами (каждая знает когда ей отображаться) */}
          <NoGroup />
          <ByAllowances />
          <ByAllowancesAndFoodModes />
          <Students />
          <Classes />
          {/* <Schools /> */}
          <ClassesAndOrders />
        </React.Fragment>}
    </ReportSection>
  );
};

export default enhanceReport(Report);
